export default __webpack_public_path__ + "static/media/DataQuality.0e4b7896.svg";